export type DeployEnvironment = 'local' | 'development' | 'staging' | 'production';

const normalizeDeployEnv = (value?: string): DeployEnvironment | undefined => {
  const normalized = value?.trim().toLowerCase();

  if (!normalized) {
    return undefined;
  }

  if (['local'].includes(normalized)) {
    return 'local';
  }
  if (['dev', 'development'].includes(normalized)) {
    return 'development';
  }
  if (['stage', 'staging'].includes(normalized)) {
    return 'staging';
  }
  if (['prod', 'production'].includes(normalized)) {
    return 'production';
  }

  return undefined;
};

export const getDeployEnvironment = (): DeployEnvironment => {
  return (
    normalizeDeployEnv(process.env.REACT_APP_DEPLOY_ENV) ??
    normalizeDeployEnv(process.env.REACT_APP_ENV) ??
    (process.env.NODE_ENV === 'production' ? 'production' : 'local')
  );
};
